(function () {
  if (window.SmallSmileContactPage) return;
  window.SmallSmileContactPage = true;

  var EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function topicFrom(node) {
    return node && node.closest('[data-contact-topic]');
  }

  function closeTopic(topic) {
    if (!topic) return;
    var toggle = topic.querySelector('[data-topic-toggle]');
    var menu = topic.querySelector('[data-topic-menu]');
    topic.classList.remove('is-open');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
    if (menu) menu.hidden = true;
  }

  function openTopic(topic) {
    document.querySelectorAll('[data-contact-topic].is-open').forEach(function (open) {
      if (open !== topic) closeTopic(open);
    });
    var toggle = topic.querySelector('[data-topic-toggle]');
    var menu = topic.querySelector('[data-topic-menu]');
    topic.classList.add('is-open');
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
    if (menu) menu.hidden = false;
  }

  function selectOption(option) {
    var topic = topicFrom(option);
    if (!topic) return;
    var value = option.getAttribute('data-value') || '';
    var input = topic.querySelector('[data-topic-input]');
    var label = topic.querySelector('[data-topic-value]');
    if (input) input.value = value;
    if (label) label.textContent = option.textContent.trim();
    topic.classList.add('is-filled');
    topic.querySelectorAll('[data-topic-option]').forEach(function (item) {
      item.setAttribute('aria-selected', item === option ? 'true' : 'false');
    });
    closeTopic(topic);
    clearFieldError(fieldWrap(topic));
    var toggle = topic.querySelector('[data-topic-toggle]');
    if (toggle) toggle.focus();
  }

  function fieldWrap(node) {
    return node && node.closest('[data-field]');
  }

  function setFieldError(wrap, message) {
    if (!wrap) return;
    var input = wrap.querySelector('[data-contact-input]');
    var toggle = wrap.querySelector('[data-topic-toggle]');
    var error = wrap.querySelector('[data-field-error]');
    wrap.classList.add('is-invalid');
    if (input) input.setAttribute('aria-invalid', 'true');
    if (toggle) toggle.setAttribute('aria-invalid', 'true');
    if (error) {
      error.textContent = message || '';
      error.hidden = !message;
    }
  }

  function clearFieldError(wrap) {
    if (!wrap) return;
    var input = wrap.querySelector('[data-contact-input]');
    var toggle = wrap.querySelector('[data-topic-toggle]');
    var error = wrap.querySelector('[data-field-error]');
    wrap.classList.remove('is-invalid');
    if (input) input.removeAttribute('aria-invalid');
    if (toggle) toggle.removeAttribute('aria-invalid');
    if (error) {
      error.textContent = '';
      error.hidden = true;
    }
  }

  function messagesRoot(form) {
    return (form && form.querySelector('[data-contact-fields]')) || form;
  }

  function errorMessage(form, key, fallback) {
    var root = messagesRoot(form);
    return (root && root.getAttribute('data-error-' + key)) || fallback || '';
  }

  function validateName(form, input) {
    var value = (input.value || '').trim();
    if (!value) return errorMessage(form, 'name-required', 'Please enter your name');
    return '';
  }

  function validateEmail(form, input) {
    var value = (input.value || '').trim();
    if (!value) return errorMessage(form, 'email-required', 'Please enter your email');
    if (!EMAIL_PATTERN.test(value)) {
      return errorMessage(form, 'email-invalid', 'Please enter a valid email address');
    }
    return '';
  }

  function validateMessage(form, input) {
    var value = (input.value || '').trim();
    if (!value) return errorMessage(form, 'message-required', 'Please enter your message');
    return '';
  }

  function validateTopic(form, input) {
    var value = (input.value || '').trim();
    if (!value) return errorMessage(form, 'topic-required', 'Please select a topic');
    return '';
  }

  function validateField(form, input) {
    if (!input) return '';
    var type = input.getAttribute('data-contact-input');
    if (type === 'name') return validateName(form, input);
    if (type === 'email') return validateEmail(form, input);
    if (type === 'topic') return validateTopic(form, input);
    if (type === 'message') return validateMessage(form, input);
    return '';
  }

  function focusTargetFor(input) {
    if (!input) return null;
    if (input.getAttribute('data-contact-input') === 'topic') {
      var wrap = fieldWrap(input);
      return (wrap && wrap.querySelector('[data-topic-toggle]')) || input;
    }
    return input;
  }

  function isContactForm(form) {
    return !!(form && form.classList && form.classList.contains('contact-page__form'));
  }

  function validateForm(form) {
    var firstInvalid = null;
    var valid = true;

    form.querySelectorAll('[data-contact-input]').forEach(function (input) {
      var wrap = fieldWrap(input);
      var message = validateField(form, input);
      if (message) {
        valid = false;
        setFieldError(wrap, message);
        if (!firstInvalid) firstInvalid = focusTargetFor(input);
      } else {
        clearFieldError(wrap);
      }
    });

    if (firstInvalid) {
      firstInvalid.focus();
      if (typeof firstInvalid.scrollIntoView === 'function') {
        firstInvalid.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }
    }

    return valid;
  }

  function submitContactForm(form) {
    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
      return;
    }
    HTMLFormElement.prototype.submit.call(form);
  }

  function onContactSubmit(event) {
    var form = event.target;
    if (!isContactForm(form)) return;
    if (validateForm(form)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }

  function onContactSubmitClick(event) {
    var button = event.target.closest('[data-contact-submit]');
    if (!button) return;
    var form = button.closest('.contact-page__form');
    if (!isContactForm(form)) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    if (!validateForm(form)) return;
    submitContactForm(form);
  }

  function onContactFieldKeydown(event) {
    if (event.key !== 'Enter') return;
    if (event.target.tagName === 'TEXTAREA') return;
    if (!event.target.closest('[data-contact-input]')) return;
    var form = event.target.closest('.contact-page__form');
    if (!isContactForm(form)) return;

    event.preventDefault();
    if (!validateForm(form)) return;
    submitContactForm(form);
  }

  function bindContactForms() {
    document.querySelectorAll('.contact-page__form').forEach(function (form) {
      form.noValidate = true;
    });
  }

  document.addEventListener('submit', onContactSubmit, true);
  document.addEventListener('click', onContactSubmitClick, true);
  document.addEventListener('keydown', onContactFieldKeydown, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindContactForms);
  } else {
    bindContactForms();
  }

  document.addEventListener('shopify:section:load', bindContactForms);

  document.addEventListener('input', function (event) {
    var input = event.target.closest('[data-contact-input]');
    if (!input) return;
    var form = input.closest('.contact-page__form');
    if (!isContactForm(form)) return;
    var wrap = fieldWrap(input);
    if (!wrap || !wrap.classList.contains('is-invalid')) return;
    var message = validateField(form, input);
    if (message) setFieldError(wrap, message);
    else clearFieldError(wrap);
  });

  document.addEventListener('blur', function (event) {
    var input = event.target.closest('[data-contact-input]');
    if (!input) return;
    var form = input.closest('.contact-page__form');
    if (!isContactForm(form)) return;
    var wrap = fieldWrap(input);
    if (!wrap) return;
    var hasValue = (input.value || '').trim().length > 0;
    if (!hasValue && !wrap.classList.contains('is-invalid')) return;
    var message = validateField(form, input);
    if (message) setFieldError(wrap, message);
    else clearFieldError(wrap);
  }, true);

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-topic-toggle]');
    if (toggle) {
      var topic = topicFrom(toggle);
      if (topic.classList.contains('is-open')) closeTopic(topic);
      else openTopic(topic);
      return;
    }

    var option = event.target.closest('[data-topic-option]');
    if (option) {
      selectOption(option);
      return;
    }

    var again = event.target.closest('[data-contact-again]');
    if (again) {
      var form = again.closest('form');
      var sent = form && form.querySelector('[data-contact-success]');
      var fields = form && form.querySelector('[data-contact-fields]');
      if (sent) sent.hidden = true;
      if (fields) {
        fields.hidden = false;
        var first = fields.querySelector('input, textarea');
        if (first) first.focus();
      }
      return;
    }

    if (!event.target.closest('[data-contact-topic]')) {
      document.querySelectorAll('[data-contact-topic].is-open').forEach(closeTopic);
    }
  });

  document.addEventListener('keydown', function (event) {
    var topic = topicFrom(event.target);
    if (!topic || !topic.classList.contains('is-open')) {
      if (event.key === 'Escape') {
        document.querySelectorAll('[data-contact-topic].is-open').forEach(closeTopic);
      }
      return;
    }

    var options = Array.prototype.slice.call(topic.querySelectorAll('[data-topic-option]'));
    var current = options.indexOf(document.activeElement);
    if (current < 0) {
      current = options.findIndex(function (option) {
        return option.getAttribute('aria-selected') === 'true';
      });
    }

    if (event.key === 'Escape') {
      closeTopic(topic);
      var toggle = topic.querySelector('[data-topic-toggle]');
      if (toggle) toggle.focus();
      return;
    }

    if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
      event.preventDefault();
      if (!options.length) return;
      var next = event.key === 'ArrowDown' ? current + 1 : current - 1;
      if (next < 0) next = options.length - 1;
      if (next >= options.length) next = 0;
      options[next].focus();
    }
  });
})();
